// Normalizador central de RUT/RUC para comparación por clave natural (regla 10.7).
//
// Quita TODO lo que no sea dígito o K/k y uppercasea la K. Cubre los formatos heterogéneos
// que hay hoy en DB: con puntos, guión ASCII "-", guión Unicode "−" (U+2212), espacios, y
// RUT sin DV separado.
//   "76.811.980-5" / "76811980-5" / "76.811.980−5" / "768119805" → "768119805"
// Vacío / null / undefined → "".
//
// Uso: comparar normalizarRut(a) === normalizarRut(b) para detectar la MISMA entidad aunque
// los strings difieran en formato. NO se usa para display (para eso está `formatRut` de abajo).
export const normalizarRut = (rut) => {
  if (!rut) return "";
  return String(rut)
    .replace(/[^\dKk]/g, "")
    .toUpperCase();
};

// Formatea un RUT/RUC para DISPLAY: cuerpo con separador de miles es-CL + "-" + DV.
//   "76811980-5" → "76.811.980-5". Sin DV separado → devuelve el rut tal cual. Vacío/null → "-".
// Fuente única del formatRut que estaba DUPLICADO IDÉNTICO en 4 componentes (ConciliacionSII/index,
// VincularEmitidaModal, AsignarRecibidaModal, SeleccionarDTEModal). NO cubre el `formatRut` de
// ComprasTab (devuelve null en vez de "-") ni el de GestionProveedores (regex de miles + fallback
// "—"), que tienen comportamiento propio y conservan su versión local. Regla 10.1.
export const formatRut = (rut) => {
  if (!rut) return "-";
  const [cuerpo, dv] = rut.split("-");
  if (!dv) return rut;
  return `${Number(cuerpo).toLocaleString("es-CL")}-${dv}`;
};
